var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"am-vehicle-player-thumbnail-image",class:{
    'am-vehicle-player-thumbnail-image--active': _vm.active
  }},[_c('picture',[_vm._l((_vm.sources),function(source,i){return _c('source',{key:i,attrs:{"media":source.media,"srcset":source.srcset}})}),_c('img',{attrs:{"src":_vm.fallbackSource.srcset,"draggable":"false","alt":_vm.alt}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }